import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button } from "react-bootstrap";
import { FaMagnifyingGlass } from "react-icons/fa6";
import TableUI from "../../components/Table";
import { Buttons } from "../../../src/components/Buttons";
import { TextInputForm, DropDownUII } from "../../components/Forms";
import { useMediaQuery } from "react-responsive";
import { ClickButton } from "../../components/ClickButton";
import { useNavigate } from "react-router-dom";
import MobileView from "../../components/MobileView";
import Offcanvas from "react-bootstrap/Offcanvas";
import { IoMdCloseCircle } from "react-icons/io";
import { IoFilter } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import API_DOMAIN from "../../config/config";
import LoadingOverlay from "../../components/LoadingOverlay";

const UserTablehead = [
  "Date",
  "அடகு எண்",
  "வாடிக்கையாளர் பெயர்",
  "கைபேசி எண்",
  "அசல் தொகை",
  "வட்டி விகிதம்",
  "மொத்த எடை",
  "அடகு பொருள்கள் ",
  "Status",
  "செயல்",
];

const User = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    ReceiptNo: "",
  });
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterOptions, setFilterOptions] = useState({
    receipt_nos: [],
    names: [],
  });
  const itemsPerPage = 10;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleLoad = () => {
    setFormData({ name: "", ReceiptNo: "" });
    setSearchText("");
    setCurrentPage(1);
  };


  const fetchFilterOptions = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "get_filter_options",
        }),
      });

      const responseData = await response.json();
      console.log("filterOptions", responseData);

      if (responseData.head.code === 200) {
        setFilterOptions({
          receipt_nos: responseData.body.receipt_nos,
          names: responseData.body.names,
        });
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      console.error("Error fetching filter options:", error.message);
    }
  };

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search_text: searchText,
          name: formData.name,
          receipt_no: formData.ReceiptNo,
          limit: itemsPerPage,
          offset: (page - 1) * itemsPerPage,
        }),
      });

      const responseData = await response.json();
      console.log("responseData", responseData);

      if (responseData.head.code === 200) {
        let sortedData = responseData.body.pawnjewelry.map((user) => ({
          ...user,
          jewel_product: JSON.parse(user.jewel_product || "[]"),
        }));

        sortedData.sort(
          (a, b) => parseInt(a.receipt_no) - parseInt(b.receipt_no)
        );
        setUserData(sortedData);
        setTotalRecords(responseData.body.total_records);
        setLoading(false);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchData(currentPage);
  }, [formData, searchText, currentPage, itemsPerPage]);

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const nextPage = () => {
    if (currentPage < Math.ceil(totalRecords / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg="7" md="6" xs="6">
            <div className="page-nav py-3">
              <span className="nav-list">நகை அடகு</span>
            </div>
          </Col>
          <Col lg="5" md="6" xs="6" className="align-self-center text-end">
            <ClickButton
              label={<>Add New</>}
              onClick={() => navigate("/console/pawn/jewelpawning/create")}
            />
          </Col>
          <Col lg="3" md="12" xs="12" className="py-1">
            <TextInputForm
              placeholder={"பெயர் ,மொபைல் எண்."}
              onChange={(e) => handleSearch(e.target.value)}
              prefix_icon={<FaMagnifyingGlass />}
            />
          </Col>

          {loading ? (
            <LoadingOverlay isLoading={loading} />
          ) : (
            <Col lg="12" md="12" xs="12" className="px-0">
              <div className="py-1">

                <div className="text-end">
                  <span className="mx-1">
                    Page {currentPage} of{" "}
                    {Math.ceil(totalRecords / itemsPerPage)}
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronLeft />}
                      onClick={prevPage}
                      disabled={currentPage === 1}
                    />
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronRight />}
                      onClick={nextPage}
                      disabled={
                        currentPage === Math.ceil(totalRecords / itemsPerPage)
                      }
                    />
                  </span>
                </div>
                <TableUI
                  headers={UserTablehead}
                  body={userData}
                  type="jewelPawning"
                  pageview="No"
                  style={{ borderRadius: "5px" }}
                />
                <div className="text-end">
                  <span className="mx-1">
                    Page {currentPage} of{" "}
                    {Math.ceil(totalRecords / itemsPerPage)}
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronLeft />}
                      onClick={prevPage}
                      disabled={currentPage === 1}
                    />
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronRight />}
                      onClick={nextPage}
                      disabled={
                        currentPage === Math.ceil(totalRecords / itemsPerPage)
                      }
                    />
                  </span>
                </div>
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default User;
